(() => {
  const metric = 'Plantadecor Cart Snapshot';
  let timer;
  let lastFingerprint = '';

  async function publishCart() {
    try {
      if (!window.klaviyo?.track && !Array.isArray(window._learnq)) {
  window._learnq = window._learnq || [];
}
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
        credentials: 'same-origin', cache: 'no-store'
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (!cart.items?.length) {
  if (lastFingerprint === 'empty') return;
  lastFingerprint = 'empty';
  const properties = {
    CartRestoreURL: '',
    CartItemCount: 0,
    CartValue: 0,
    CartVariantQuantities: [],
    CartSnapshotStatus: 'empty',
    Source: 'plantadecor-theme-v2'
  };
  if (window.klaviyo?.track) {
    window.klaviyo.track(metric, properties);
  } else {
    window._learnq.push(['track', metric, properties]);
  }
  return;
}
      if (cart.items.some(item => item.selling_plan_allocation || Object.keys(item.properties || {}).length)) return;
      const quantities = new Map();
      for (const item of cart.items) {
        if (!Number.isSafeInteger(item.variant_id) || !Number.isSafeInteger(item.quantity) || item.quantity < 1) return;
        quantities.set(item.variant_id, (quantities.get(item.variant_id) || 0) + item.quantity);
      }
      const parts = [...quantities].map(([id, quantity]) => `${id}:${quantity}`);
      const url = `${location.origin}/cart/${parts.join(',')}?storefront=true`;
      if (url.length > 1800) return;
      const fingerprint = parts.join(',');
      if (lastFingerprint === fingerprint) return;
      lastFingerprint = fingerprint;
   const properties = {
  CartRestoreURL: url,
  CartItemCount: cart.item_count,
  CartValue: cart.total_price / 100,
  CartVariantQuantities: parts,
  Source: 'plantadecor-theme-v1'
};

if (window.klaviyo?.track) {
  window.klaviyo.track(metric, properties);
} else {
  window._learnq.push(['track', metric, properties]);
}
    } catch (error) {
      console.warn('Cart snapshot unavailable', error);
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(publishCart, 350);
  }

  document.addEventListener('product-ajax:added', schedule);
  document.addEventListener('cart:updated', schedule);
  if (window.MinimogEvents?.subscribe && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, schedule);
  }
})();
